import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'

const oak_ca_resources = {
  en: {
    ...contactInfo_en,
  },
  fr: {
    ...contactInfo_fr,
  },
}

export default oak_ca_resources
